import { ReactNode } from 'react';
import { Filter, FilterItem } from '@wix/bex-core';
import {
  AccordionProps,
  PopoverCommonProps,
  TagListProps,
} from '@wix/design-system';

export interface FilterProps<V> {
  /**
   * A filter state object such as [ArrayFilter](/pages/cairo/?path=/story/common-factories--arrayfilter)
   * @external
   */
  filter: Filter<V>;

  /**
   * layout="button" removes padding from the sides of the filter within the toolbar
   * @external
   */
  layout?: 'button';
  /**
   * Customize the filter inside the table toolbar
   * - `label`: A prefix label for the filter element
   * @external
   */
  toolbarItemProps?: {
    label?: ReactNode;
  };
  /**
   * Indicates whether the filter should be visible by default in the filters panel
   * @external
   */
  initiallyOpen?: boolean;
  /**
   * Customize the filter accordion item, when it's being rendered in the filters panel
   * - Extends [AccordionProps['items'][number]](https://www.docs.wixdesignsystem.com/?path=/story/components-lists--accordion)
   * - `label`: the title of the accordion item (Use `AccordionProps['items'][number].title` for more flexibility)
   * @external
   */
  accordionItemProps?: Required<AccordionProps>['items'][number] & {
    label?: string;
  };

  // @deprecated
  popoverProps?: PopoverCommonProps;

  /**
   * Called when a filter tag is being removed by the user from sub-toolbar
   * @param item
   * @external
   */
  onAppliedFilterTagRemove?: (item: FilterItem<V>) => unknown;
  /**
   * Customize rendering of a tag sub-toolbar tag list
   * @external
   */
  renderToolbarTag?: (
    item: FilterItem<V>,
  ) => Partial<TagListProps['tags'][number]>;

  explodeTags?: boolean;

  /**
   * Groups accordions by title
   * @external
   */
  sectionTitle?: string;
}
